export default __webpack_public_path__ + "static/media/icon.2bb18abb.png";